import React, {Component} from 'react';
import {browserHistory} from 'react-router'
import {connect} from 'react-redux';
import {loginPressed} from '../actions';
import SignUp from './SignUp';
import Load from './Load';
import AuthError from './AuthError'
import EmailInput from './common/EmailInput';
import PasswordInput from './common/PasswordInput';
import {pwReset} from "../actions/index";
import logo from '../../resources/images/logo_grey.png'

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            signUp: false,
            logIn: false
        };
    }

    handleEmailInput = (e) => {
        this.setState({email: e});
    }

    handlePasswordInput = (e) => {
        this.setState({password: e});
    }

    handleLogin = () => {
        this.props.dispatch(loginPressed(this.state.email, this.state.password))
    }

    loginWithEmail = () => {
        this.props.dispatch(pwReset(false));
        this.setState({logIn: !this.state.logIn})
    }

    handleSignUp = () => {
        this.setState({signUp: !this.state.signUp})
    }

    keyDown = (e) => {
        //console.log(e.keyCode)
        if (e.keyCode === 13) {
            this.handleLogin()
        }
    }

    render() {
        //console.log('login',this.props.routeParams);

        const hideSignupOption = true //true on release, false for testing

        let signUpOptions =
            <div className="login-options">
                <button onClick={() => this.loginWithEmail()}>Login with Email</button>
                <div className="login-options-dividing-line">
                    <span>Or</span>
                </div>
                <button onClick={this.handleSignUp}>Sign Up</button>
            </div>
        if (hideSignupOption || this.state.logIn) {
            signUpOptions =
                <div onKeyDown={this.keyDown}>
                    {!hideSignupOption && <a className="login-back-button" onClick={this.loginWithEmail}>Back</a>}
                    <EmailInput label="Email address" placeholder="" onChange={this.handleEmailInput}/>
                    <PasswordInput label="Password" placeholder="" onChange={this.handlePasswordInput}/>
                    <button className="submit sign-in-button" onClick={this.handleLogin}>Sign in</button>
                    <button className="link forgot-password" onClick={() => browserHistory.push('/passwordReset')}>Forgot password?</button>
                    <button className="link forgot-password" onClick={() => browserHistory.push('/support')}>Send support message</button>
                </div>;
        } else if (this.state.signUp) {
            signUpOptions = <SignUp backButtonClicked={this.handleSignUp}/>;
        }

        //console.log('login_ props', this.props.loading)
        return (
            <div className="login-box">
                <img style={{float: 'right', width: '140px', height: '70px'}} src={logo} alt="logo"/>

                <div className="sign-in">SIGN IN</div>

                {signUpOptions}

                {this.props.auth.error && <AuthError />}
                {this.props.loading.loginPressed && this.props.auth.error !== 'ETMS_LOGIN_ERROR' && <Load />}

            </div>
        );
    }
}

export default Login = connect((state) => {
    return {
        auth: state.auth,
        loading: (state.data || {}).loading || {}
    }
})(Login);



// WEBPACK FOOTER //
// ./src/components/Login.jsx